// tipoBonifMatricula que el checkout pide a getCoste para un usuario reconocido
// de la comunidad UAI, POR TIPO DE PROGRAMA (query param "t").
//
// En SIGUE existen dos tipos de bonificación de matrícula (bonif_matr_cat,
// categoría 'tipoBonifMatricula'):
//   - 'NuevosIngresantes': default del SP cuando no se manda tipo (aspirantes nuevos).
//   - 'Alumnos': usuarios reconocidos de la comunidad UAI (este flujo).
// El PORCENTAJE de cada una lo gobierna administración en bonif_matr (por año,
// etapa, vigencia y alcance campus/carrera); el checkout solo elige el tipo.
const TIPO_BONIF_COMUNIDAD = {
  g: 'alumnos',
  p: 'alumnos',
  e: 'alumnos',
  m: 'alumnos',
};

// Devuelve el tipoBonifMatricula a usar para comunidad, o null si para este
// tipo de programa no corresponde bonificación de comunidad.
export const tipoBonifComunidad = (t) => TIPO_BONIF_COMUNIDAD[t?.toLowerCase()] ?? null;

export default TIPO_BONIF_COMUNIDAD;
